import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-generic-confirmation-dialog',
  templateUrl: './generic-confirmation-dialog.component.html',
  styleUrls: ['./generic-confirmation-dialog.component.scss']
})
/*
 * Generic confirmation dialog component
 * 
 * Displays a customizable confirmation dialog with the following features:
 * - Accepts header and main text as input parameters
 * - Provides Yes/No button options for user response
 * - Emits the user's selection (Yes/No) through the afterClosed event
*/
export class GenericConfirmationDialogComponent implements OnInit {

  dialogText:any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<GenericConfirmationDialogComponent>
  ) { }
  ngOnInit(): void {
    this.dialogText=this.data;
  }
  closeDialog(res) {
    this.dialogRef.close(res);
  }
}
